import React from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"
import { DckSelectors, DckActionCreators } from "dck-redux"

import * as ItemTypes from "../../redux/items/types"
import { browserHistory, Link } from "react-router"
import FontAwesome from "react-fontawesome"
import { getBusinessName, sortDate } from "../../lib/utils"
import Authenticated from "../../lib/Authenticated"
import SingleSelectTable from "../fragments/SingleSelectTable"
import ClearFiltersButton from "../fragments/ClearFiltersButton"
import UIAvatar from "../fragments/UIAvatar"

class ListBusinesses extends React.Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  componentDidMount() {
    this.props.loadBusinesses()
  }

  doClearFilters = () => {
    this.refs.name.cleanFiltered()
    this.refs.businessId.cleanFiltered()
    this.refs.phoneNumber.cleanFiltered()
    this.refs.createdOnFormatted.cleanFiltered()
  }

  renderUpdateLink = businessId => {

    if(!this.isAdmin) return null
    return (
      <Link to={`/businesses/${businessId}/update`} className='p-5'>
        <FontAwesome name="pencil" title='Update' />
      </Link>
    )
  }

  getLinkToDetails = (id, name) =>
    <Link to={`/businesses/${id}/detail`} title='Show details' className='p-5'>
      { name }
    </Link>

  render() {
    const { businesses } = this.props
    return (
      <div>

        <ClearFiltersButton onClick={ this.doClearFilters } />

        <SingleSelectTable
          items={ businesses }
          addNewLabel="New Business"
          addNewHandler={() => browserHistory.push("/businesses/create")}
          shouldRenderToolbar={ this.isAdmin }
          exportCSV={ this.isAdmin }
          csvFileName='Businesses.csv'
        >
          <TableHeaderColumn
            dataField="id"
            isKey
            dataAlign="center"
            dataFormat={(_, row) => <UIAvatar name={ getBusinessName(row) } size={ 28 } />}
            csvHeader="ID"
            width='48px'
          />

          <TableHeaderColumn
            ref='name'
            dataField="name"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataFormat={(name, row) => this.getLinkToDetails(row.id, name)}
            csvHeader="Name"
            columnClassName="min-w-120"
          >
            Name
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='businessId'
            dataField="businessId"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="Business ID"
            dataFormat={(businessId, row) => this.getLinkToDetails(row.id, businessId)}
            csvFieldType="string"
            columnClassName="min-w-120"
          >
            Business ID
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='phoneNumber'
            dataField="phoneNumber"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="Phone number"
            columnClassName="min-w-120"
          >
            Phone number
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='createdOnFormatted'
            dataField="createdOnFormatted"
            dataAlign="center"
            dataSort
            sortFunc={(a, b, order) => sortDate(a.createdOn, b.createdOn, order)}
            filter={{ type: "DateFilter", delay: 1000 }}
            csvHeader="Created On"
            columnClassName="text-xs min-w-120"
          >
            Created On
          </TableHeaderColumn>

          <TableHeaderColumn
            dataAlign="center"
            width="80px"
            dataFormat={(_, row) =>
              <span className="flex-detail">
                { this.getLinkToDetails(row.id, <FontAwesome name="eye" title='View' />) }
                { this.renderUpdateLink(row.id) }
              </span>
            }
          />
        </SingleSelectTable>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const businesses = DckSelectors.selectAllItems(state, ItemTypes.Business)
  return { businesses }
},

mapDispatchToProps = dispatch => ({
  loadBusinesses: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Business)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListBusinesses)



// WEBPACK FOOTER //
// ./src/components/Business/List.js